/* eslint-disable no-unused-vars */
import './App.css';
import { useState, useEffect } from 'react';

function App() {
  const [isLoading, setIsLoading] = useState(true);
  const [selectedTrack, setSelectedTrack] = useState(null);
  const [openFaq, setOpenFaq] = useState(null);

  const scholarshipTracks = [
    {
      id: 1,
      title: "Data Analysis",
      icon: "📊",
      description: "تحليل البيانات واستخراج الرؤى القيمة منها",
      skills: ["Statistics", "Excel", "SQL", "Python", "Power BI"],
      duration: "4 أشهر",
      instructors: ["Yousef Ismail"],
      introLink: "https://youtu.be/0pWssYwioo0?si=6Y5J9w50umKI2z6K"
    },
    {
      id: 2,
      title: "Cyber Security",
      icon: "🔐",
      description: "حماية الأنظمة والشبكات من التهديدات السيبرانية",
      skills: ["Penetration Testing", "Network Security", "linux" , "windows"],
      duration: "6 أشهر",
      instructors: ["abdulrahman alaa"],
      introLink: "https://youtu.be/QHmYRpLj9mo?si=inc698bYFulUDnCK"
    },
    {
      id: 3,
      title: "Cloud Computing",
      icon: "☁️",
      description: "إدارة البنية التحتية والنشر السحابي",
      skills: ["AWS", "Azure", "Google Cloud", "Docker", "Kubernetes"],
      duration: "4 أشهر",
      // instructors: ["abdulrahman alaa", "mahmoud habib", "mohab mohamed"],
      // introLink: "https://www.youtube.com/watch?v=cloud-computing-intro"
    },
    {
      id: 4,
      title: "Front end",
      icon: "💻",
      description: "تطوير واجهات المستخدم التفاعلية والحديثة",
      skills: ["HTML5", "CSS3", "JavaScript", "Bootstrap", "React js", "Tailwind Css", "Redux ToolKit"],
      duration: "4 أشهر",
      instructors: ["abdulrahman alaa", "mahmoud habib", "mohab mohamed"],
      introLink: "https://youtu.be/8NfwNOkyty0?si=lXotNC2boyrSgI9i"
    },
    {
      id: 5,
      title: "Back end",
      icon: "⚙️",
      description: "بناء الخوادم والـ APIs والقواعد البيانات",
      skills: ["Node js", "Express js", "Mongo DB"],
      duration: "3 أشهر",
      instructors: ["Mohamed Omar"],
      introLink: "https://youtu.be/PKrcbFNPjXQ?si=MABDXYNRLehrw39Z"
    },
    {
      id: 6,
      title: "Mobile apps",
      icon: "📱",
      description: "تطوير تطبيقات الهاتف المحمول الأصلية والهجينة",
      skills: ["Dart", "OOP", "Flutter", "Firebase"],
      duration: "4 أشهر",
      instructors: ["Ahmed alaa"],
      // introLink: "https://www.youtube.com/watch?v=mobile-apps-intro"
    },
    {
      id: 7,
      title: "DevOps",
      icon: "🔧",
      description: "تطوير العمليات وأتمتة النشر والتكامل المستمر",
      skills: ["Jenkins", "GitLab CI", "Docker", "Kubernetes", "Terraform"],
      duration: "4 أشهر",
      // instructors: ["abdulrahman alaa", "mahmoud habib", "mohab mohamed"],
      // introLink: "https://www.youtube.com/watch?v=devops-intro"
    },
    {
      id: 8,
      title: "Ai (Artificial Intelligence)",
      icon: "🤖",
      description: "الذكاء الاصطناعي وتطبيقاته المتقدمة",
      skills: ["Python", "TensorFlow", "PyTorch", "OpenCV", "NLP"],
      duration: "6 أشهر",
      // instructors: ["abdulrahman alaa", "mahmoud habib", "mohab mohamed"],
      // introLink: "https://www.youtube.com/watch?v=ai-intro"
    },
    {
      id: 9,
      title: "Machine Learning",
      icon: "🧠",
      description: "التعلم الآلي وبناء النماذج التنبؤية",
      skills: ["Scikit-learn", "Pandas", "NumPy", "Matplotlib", "Seaborn"],
      duration: "4 أشهر",
      // instructors: ["abdulrahman alaa", "mahmoud habib", "mohab mohamed"],
      // introLink: "https://www.youtube.com/watch?v=ml-intro"
    },
    // {
    //   id: 10,
    //   title: "Network",
    //   icon: "🌐",
    //   description: "تصميم وإدارة الشبكات والبنية التحتية",
    //   skills: ["Cisco", "Network Protocols", "Routing", "Switching", "VPN"],
    //   duration: "6 أشهر",
    //   instructors: ["abdulrahman alaa", "mahmoud habib", "mohab mohamed"]
    // },
    {
      id: 10,
      title: "Ui Ux Design",
      icon: "🎨",
      description: "تصميم تجربة وواجهة المستخدم الاحترافية",
      skills: ["Figma", "Adobe XD", "Prototyping", "User Research"],
      duration: "3 أشهر",
      instructors: ["ShwQi Mohamed"],
      // introLink: "https://www.youtube.com/watch?v=ui-ux-intro"
    },
    {
      id: 11,
      title: "Ai Automation",
      icon: "⚡",
      description: "أتمتة العمليات باستخدام الذكاء الاصطناعي",
      skills: ["Automation Tools", "Workflow Design"],
      duration: "3 أشهر",
      // instructors: ["abdulrahman alaa", "mahmoud habib", "mohab mohamed"],
      // introLink: "https://www.youtube.com/watch?v=ai-automation-intro"
    },
    // {
    //   id: 13,
    //   title: "Video Editing",
    //   icon: "🎬",
    //   description: "تحرير الفيديو والمونتاج الاحترافي",
    //   skills: ["Adobe Premiere", "After Effects", "Final Cut Pro", "DaVinci Resolve"],
    //   duration: "6 أشهر",
    //   instructors: ["abdulrahman alaa", "mahmoud habib", "mohab mohamed"]
    // },
    {
      id: 12,
      title: "Media Buying",
      icon: "📈",
      description: "شراء المساحات الإعلانية وتحسين الحملات التسويقية",
      skills: ["Facebook Ads", "Google Ads", "Instagram Ads", "Analytics"],
      duration: "6 أشهر",
      instructors: ["Malek Elsawaf"],
      // introLink: "https://www.youtube.com/watch?v=media-buying-intro"
    },
    {
      id: 13,
      title: "Soft Skills",
      icon: "💼",
      description: "المهارات الناعمة والقيادية والتواصل",
      skills: ["Leadership", "Communication", "Teamwork", "Problem Solving", "Time Management"],
      duration: "2 أشهر",
      // instructors: ["abdulrahman alaa", "mahmoud habib", "mohab mohamed"],
      // introLink: "https://www.youtube.com/watch?v=soft-skills-intro"
    }
  ];

  const handleApplyClick = () => {
    handleWhatsAppContact();
  };

  const handleWhatsAppContact = () => {
    window.open('https://wa.me/201064663594', '_blank');
  };

  const handleTrackClick = (track) => {
    setSelectedTrack(track);
  };

  const closeTrackModal = () => {
    setSelectedTrack(null);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 3000); // 3 seconds loading time

    return () => clearTimeout(timer);
  }, []);

  // Loading Page Component
  const LoadingPage = () => (
    <div className="loading-container">
      <div className="loading-content">
        <div className="logo-container">
          <div className="loading-logo">
            <div className="scholarship-icon">🎓</div>
            <div className="tech-icons">
              <span className="icon">💻</span>
              <span className="icon">🚀</span>
              <span className="icon">⚡</span>
            </div>
          </div>
        </div>
        
        <h1 className="loading-title">
         انا عبدالرحمن علاء وبقدملك المنحة الأضخم في العالم العربي 
          <span className="loading-subtitle">لكل الشباب العربي</span>
        </h1>
        
        <div className="loading-spinner">
          <div className="spinner-ring"></div>
          <div className="spinner-ring"></div>
          <div className="spinner-ring"></div>
        </div>
        
        <div className="loading-text">
          <p>جاري تحضير المنحة المثالية لك...</p>
          <div className="loading-progress">
            <div className="progress-bar"></div>
          </div>
        </div>
        
        <div className="floating-elements">
          <div className="float-element">📊</div>
          <div className="float-element">🎨</div>
          <div className="float-element">🔐</div>
          <div className="float-element">📱</div>
          <div className="float-element">☁️</div>
          <div className="float-element">🤖</div>
        </div>
      </div>
    </div>
  );

  if (isLoading) {
    return <LoadingPage />;
  }

  return (
    <div className="App">
      {/* Hero Section */}
      <section className="hero-section">
        {/* Floating particles for scholarship theme */}
        <div className="floating-particles">
          <div className="particle particle-1">🎓</div>
          <div className="particle particle-2">💻</div>
          <div className="particle particle-3">🚀</div>
          <div className="particle particle-4">⚡</div>
          <div className="particle particle-5">🌟</div>
          <div className="particle particle-6">🔬</div>
          <div className="particle particle-7">💡</div>
          <div className="particle particle-8">🎯</div>
        </div>
        
        {/* Tech Network Lines */}
        <div className="tech-network">
          <svg className="network-svg" viewBox="0 0 1200 800" preserveAspectRatio="xMidYMid slice">
            <defs>
              <linearGradient id="lineGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="rgba(255, 23, 68, 0.4)"/>
                <stop offset="50%" stopColor="rgba(255, 255, 255, 0.2)"/>
                <stop offset="100%" stopColor="rgba(255, 23, 68, 0.4)"/>
              </linearGradient>
            </defs>
            
            {/* Network connection lines */}
            <line x1="100" y1="150" x2="300" y2="200" stroke="url(#lineGradient)" strokeWidth="1" className="network-line line-1"/>
            <line x1="300" y1="200" x2="500" y2="100" stroke="url(#lineGradient)" strokeWidth="1" className="network-line line-2"/>
            <line x1="500" y1="100" x2="700" y2="250" stroke="url(#lineGradient)" strokeWidth="1" className="network-line line-3"/>
            <line x1="700" y1="250" x2="900" y2="150" stroke="url(#lineGradient)" strokeWidth="1" className="network-line line-4"/>
            <line x1="200" y1="400" x2="400" y2="350" stroke="url(#lineGradient)" strokeWidth="1" className="network-line line-5"/>
            <line x1="400" y1="350" x2="600" y2="450" stroke="url(#lineGradient)" strokeWidth="1" className="network-line line-6"/>
            <line x1="600" y1="450" x2="800" y2="400" stroke="url(#lineGradient)" strokeWidth="1" className="network-line line-7"/>
            <line x1="150" y1="600" x2="350" y2="550" stroke="url(#lineGradient)" strokeWidth="1" className="network-line line-8"/>
            <line x1="350" y1="550" x2="550" y2="650" stroke="url(#lineGradient)" strokeWidth="1" className="network-line line-9"/>
            <line x1="550" y1="650" x2="750" y2="600" stroke="url(#lineGradient)" strokeWidth="1" className="network-line line-10"/>
            
            {/* Network nodes (connection points) */}
            <circle cx="100" cy="150" r="3" fill="rgba(255, 23, 68, 0.6)" className="network-node node-1"/>
            <circle cx="300" cy="200" r="4" fill="rgba(255, 255, 255, 0.8)" className="network-node node-2"/>
            <circle cx="500" cy="100" r="3" fill="rgba(255, 23, 68, 0.6)" className="network-node node-3"/>
            <circle cx="700" cy="250" r="4" fill="rgba(255, 255, 255, 0.8)" className="network-node node-4"/>
            <circle cx="900" cy="150" r="3" fill="rgba(255, 23, 68, 0.6)" className="network-node node-5"/>
            <circle cx="200" cy="400" r="4" fill="rgba(255, 255, 255, 0.8)" className="network-node node-6"/>
            <circle cx="400" cy="350" r="3" fill="rgba(255, 23, 68, 0.6)" className="network-node node-7"/>
            <circle cx="600" cy="450" r="4" fill="rgba(255, 255, 255, 0.8)" className="network-node node-8"/>
            <circle cx="800" cy="400" r="3" fill="rgba(255, 23, 68, 0.6)" className="network-node node-9"/>
            <circle cx="150" cy="600" r="4" fill="rgba(255, 255, 255, 0.8)" className="network-node node-10"/>
          </svg>
        </div>
        <div className="container">
          <div className="hero-content">
            <h1 className="hero-title">
              المنحة الأضخم في العالم العربي
              <span className="highlight">2026 </span>
            </h1>
            <p className="hero-subtitle">
              المنحة هي الأشمل في المنطقة العربية - 16 تخصص تقني متطور لتأهيل جيل جديد من المبرمجين والمطورين
            </p>
            <div className="hero-stats">
              <div className="stat">
                <span className="stat-number">16</span>
                <span className="stat-label">Live تخصص تقني</span>
              </div>
              <div className="stat">
                <span className="stat-number">لكل الاعمار</span>
                <span className="stat-label">40-14 </span>
              </div>
              <div className="stat">
                <span className="stat-number">العالم العربي</span>
                <span className="stat-label">لجميع الدول العربيه</span>
              </div>
            </div>
            <button className="cta-button" onClick={handleApplyClick}>
              سجل الآن في المنحة
            </button>
            <div className="button-spacing"></div>
          </div>
        </div>
      </section>

      {/* Video Introduction Section */}
      <section className="video-section">
        <div className="container">
          <div className="video-header">
            <h2 className="section-title">شاهد الفيديو التعريفي للمنحة</h2>
            <p className="section-subtitle">
              تعرف على المنحة الأضخم في العالم العربي وكل التفاصيل في فيديو واحد
            </p>
          </div>
                              <div className="video-container">
            <div className="video-wrapper">
              {/* 
                ⚠️ الحل الموصى به: استخدام YouTube أو خدمة استضافة فيديو
                لأن الفيديو الكبير (742MB) أكبر من حد Vercel (100MB)
                
                Option 1: YouTube (الأسهل والأفضل) ⭐
                1. ارفع الفيديو على YouTube
                2. احصل على رابط الفيديو
                3. ألغِ التعليق عن الكود أدناه واستبدل VIDEO_ID
              */}
              
              {/* YouTube Embed */}
              <iframe
                className="intro-video"
                src="https://www.youtube.com/embed/rHsvORSkMH0?rel=0&showinfo=0&modestbranding=1"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                title="الفيديو التعريفي للمنحة"
                style={{ zIndex: 10, pointerEvents: 'auto' }}
              ></iframe>
              
              {/* 
                خيارات أخرى (معطلة):
                
                Option 1: فيديو محلي
              */}
              {/*
              <video 
                ref={videoRef}
                className="intro-video"
                controls
                poster="/images/video-poster.jpg"
                onPlay={() => setIsPlaying(true)}
                onPause={() => setIsPlaying(false)}
                onTimeUpdate={(e) => {
                  const video = e.target;
                  if (video.duration) {
                    const progress = (video.currentTime / video.duration) * 100;
                    setVideoProgress(progress);
                  }
                }}
              >
                <source src="/videos/Intro-video.mp4" type="video/mp4" />
                متصفحك لا يدعم تشغيل الفيديو. يرجى تحديث المتصفح أو استخدام متصفح آخر.
              </video>
              
              <div className="video-overlay" style={{ opacity: isPlaying ? 0 : 1, pointerEvents: isPlaying ? 'none' : 'auto' }}>
                <div 
                  className="video-play-button"
                  onClick={(e) => {
                    e.stopPropagation();
                    if (videoRef.current) {
                      videoRef.current.play();
                      setIsPlaying(true);
                    }
                  }}
                >
                  <svg width="80" height="80" viewBox="0 0 80 80" fill="none">
                    <circle cx="40" cy="40" r="40" fill="rgba(255, 23, 68, 0.9)" />
                    <path d="M32 24L32 56L56 40L32 24Z" fill="white" />
                  </svg>
                </div>
              </div>
              <div className="video-progress-container">
                <div 
                  className="video-progress-bar" 
                  style={{ width: `${videoProgress}%` }}
                ></div>
              </div>
              */}
              
              {/* 
                Option 2: رابط مباشر من خدمة أخرى
              */}
              {/*
              <video 
                ref={videoRef}
                className="intro-video"
                controls
                poster="/images/video-poster.jpg"
                onPlay={() => setIsPlaying(true)}
                onPause={() => setIsPlaying(false)}
                onTimeUpdate={(e) => {
                  const video = e.target;
                  if (video.duration) {
                    const progress = (video.currentTime / video.duration) * 100;
                    setVideoProgress(progress);
                  }
                }}
              >
                <source src="YOUR_VIDEO_URL_HERE" type="video/mp4" />
                متصفحك لا يدعم تشغيل الفيديو. يرجى تحديث المتصفح أو استخدام متصفح آخر.
              </video>
              
              <div className="video-overlay" style={{ opacity: isPlaying ? 0 : 1, pointerEvents: isPlaying ? 'none' : 'auto' }}>
                <div 
                  className="video-play-button"
                  onClick={(e) => {
                    e.stopPropagation();
                    if (videoRef.current) {
                      videoRef.current.play();
                      setIsPlaying(true);
                    }
                  }}
                >
                  <svg width="80" height="80" viewBox="0 0 80 80" fill="none">
                    <circle cx="40" cy="40" r="40" fill="rgba(255, 23, 68, 0.9)" />
                    <path d="M32 24L32 56L56 40L32 24Z" fill="white" />
                  </svg>
                </div>
              </div>
              <div className="video-progress-container">
                <div 
                  className="video-progress-bar" 
                  style={{ width: `${videoProgress}%` }}
                ></div>
              </div>
              */}

              {/* 
                خيارات أخرى (معطلة):
                
                Option 1: Google Drive
              */}
              {/*
              <iframe
                className="intro-video"
                src="https://drive.google.com/file/d/FILE_ID/preview"
                frameBorder="0"
                allow="autoplay; fullscreen; encrypted-media"
                allowFullScreen
                title="الفيديو التعريفي للمنحة"
                style={{ zIndex: 10, pointerEvents: 'auto' }}
              ></iframe>
              */}
              
              {/* 
                Option 2: YouTube Embed
              */}
              {/*
              <iframe
                className="intro-video"
                src="https://www.youtube.com/embed/VIDEO_ID?autoplay=0&rel=0&showinfo=0"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                title="الفيديو التعريفي للمنحة"
                style={{ zIndex: 10 }}
              ></iframe>
              */}
            </div>
            <div className="video-info">
              <div className="video-stats">
                <div className="video-stat">
                  <span className="stat-icon">🎬</span>
                  <span className="stat-text">فيديو تعريفي شامل</span>
                </div>
                <div className="video-stat">
                  <span className="stat-icon">📚</span>
                  <span className="stat-text">16 تخصص تقني</span>
                </div>
                <div className="video-stat">
                  <span className="stat-icon">🌟</span>
                  <span className="stat-text">فرصة لا تعوض</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Tracks Section */}
      <section className="tracks-section">
        <div className="container">
          <h2 className="section-title">المسارات التقنية المتاحة</h2>
          <p className="section-subtitle">
          امامك 16 مسار تقني متخصص يغطي أحدث التقنيات والمهارات المطلوبة في السوق
          </p>
          <div className="tracks-grid">
            {scholarshipTracks.map((track, index) => {
              const introUrl = track.introLink || null;
              const hasIntroVideo = Boolean(introUrl);
              const skillList = Array.isArray(track.skills) ? track.skills : [];
              const instructorText = Array.isArray(track.instructors) && track.instructors.length > 0
                ? track.instructors.join(' - ')
                : 'سيتم الإعلان عن المدربين قريباً';
              return (
              <div 
                key={track.id} 
                className="track-card"
                onClick={() => handleTrackClick(track)}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => e.key === 'Enter' && handleTrackClick(track)}
              >
                  <div className="track-card-content">
                <div className="track-number">{String(index + 1).padStart(2, '0')}</div>
                <div className="track-icon">{track.icon}</div>
                <h3 className="track-title">{track.title}</h3>
                <p className="track-description">{track.description}</p>
                <div className="track-duration">{track.duration}</div>
              </div>
                  <div className="track-hover-panel">
                    <p className="track-panel-label">أهم المهارات</p>
                    <div className="track-skills">
                      {skillList.slice(0, 4).map((skill) => (
                        <span key={skill} className="track-skill">{skill}</span>
                      ))}
                    </div>
                    <p className="track-panel-label">يقود المسار</p>
                    <p className="track-panel-instructors">
                      {instructorText}
                    </p>
                    <div className="track-panel-duration">
                      ⏱️ {track.duration}
                    </div>
                    {hasIntroVideo ? (
                      <a 
                        href={introUrl}
                        className="track-intro-link"
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={(e) => e.stopPropagation()}
                      >
                        شاهد المقدمة
                      </a>
                    ) : (
                      <div className="track-coming-soon">
                        لسه البلان هتنزل
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>


      {/* Registration Steps Section */}
      <section className="registration-section">
        <div className="container">
          <h2 className="section-title">كيفية التسجيل في المنحة</h2>
          <p className="section-subtitle">
            اتبع هذه الخطوات البسيطة للانضمام إلى أضخم منحة تقنية في العالم العربي
          </p>
          <div className="registration-steps">
            <div className="registration-card">
              <div className="step-number">01</div>
              <h3>ادفع على فودافون كاش</h3>
              <div className="step-icon">💳</div>
              <p>ادفع رسوم التسجيل 750 جنيه مصري فقط على رقم فودافون كاش: 01064663594</p>
              <p>او</p>

              <p>ادفع رسوم التسجيل 750 جنيه مصري فقط على رقم انستا باي insta pay: 01032311716 </p>

            </div>
            <div className="registration-card">
              <div className="step-number">02</div>
              <h3>اعمل screenshot للإيصال</h3>
              <div className="step-icon">📸</div>
              <p>قم بعمل سكرين شوت واضح لإيصال الدفع واحفظه في هاتفك</p>
            </div>
            <div className="registration-card">
              <div className="step-number">03</div>
              <h3>أرسل الصورة على الواتساب</h3>
              <div className="step-icon">📲</div>
              <p>أرسل صورة الإيصال على رقم الواتساب: 01064663594</p>
            </div>
            <div className="registration-card">
              <div className="step-number">04</div>
              <h3>الانضمام لجروب المنحة</h3>
              <div className="step-icon">👥</div>
              <p>بيتم إضافتك على جروب المنحة على الواتساب خلال 24 ساعة</p>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="contact-section">
        <div className="container">
          <h2 className="section-title">تواصل معنا</h2>
          <div className="contact-content">
            <div className="contact-info">
              <h3>للتسجيل والاستفسارات</h3>
              <p>ارسل سكرين شوت الدفع على الواتساب:</p>
              <div className="whatsapp-number">
                <span>📱 01064663594</span>
              </div>
              <button className="whatsapp-button" onClick={handleWhatsAppContact}>
                سجل في المنحة الآن
              </button>
            </div>
            <div className="contact-image">
              <div className="phone-mockup">
                <div className="phone-notch"></div>
                <div className="phone-speaker"></div>
                <div className="phone-camera"></div>
                <div className="phone-screen">
                  <div className="status-bar">
                    <div className="status-left">
                      <span className="time">12:34</span>
                    </div>
                    <div className="status-right">
                      <span className="signal">📶</span>
                      <span className="wifi">📶</span>
                      <span className="battery">🔋</span>
                    </div>
                  </div>
                  <div className="whatsapp-header">
                    <div className="contact-avatar">🎓</div>
                    <div className="contact-info">
                      <div className="contact-name">المنحة الأضخم</div>
                      <div className="contact-status">متاح الآن</div>
                    </div>
                    <div className="header-actions">
                      <span className="action-icon">📞</span>
                      <span className="action-icon">📹</span>
                      <span className="action-icon">⋮</span>
                    </div>
                  </div>
                  <div className="chat-area">
                    <div className="chat-date">اليوم</div>
                    <div className="message-bubble received">
                      <div className="message-text">مرحباً بك! 👋</div>
                      <div className="message-text">أهلاً بك في أضخم منحة تقنية في العالم العربي</div>
                      <div className="message-time">12:30</div>
                    </div>
                    <div className="message-bubble sent">
                      <div className="message-text">مرحباً! أريد التسجيل في المنحة 🚀</div>
                      <div className="message-time">12:34</div>
                    </div>
                    <div className="message-bubble received">
                      <div className="message-text">ممتاز! ابعتلي سكرين شوت الدفع وهنأكدلك التسجيل فوراً ✅</div>
                      <div className="message-time">12:34</div>
                    </div>
                    <div className="typing-indicator">
                      <span className="typing-dot"></span>
                      <span className="typing-dot"></span>
                      <span className="typing-dot"></span>
                    </div>
                  </div>
                  <div className="chat-input">
                    <div className="input-field">
                      <span className="input-placeholder">اكتب رسالة...</span>
                      <div className="input-actions">
                        <span className="input-icon">📎</span>
                        <span className="input-icon">😊</span>
                        <span className="send-icon">🎤</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="phone-home-indicator"></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="testimonials-section">
        <div className="container">
          <h2 className="section-title">آراء طلابنا وتوفيق ربنا </h2>
          <p className="section-subtitle">
الحمدلله كل ده بتوفيق ربنا وفضله احنا ما الا ان ربنا جعلنا سبب في طريقهم الحمدلله مره تانيه
          </p>
          <div className="testimonials-grid">


          <div className="testimonial-card">
              <img src="images/481276425_2449946678686798_3769362669236109905_n.jpg" alt="طالب" />
            </div>

            <div className="testimonial-card">
              <img src="images/527054738_2593263227688475_3178922121604216473_n.jpg" alt="طالب" />
            </div>

            <div className="testimonial-card">
              <img src="images/481318618_2450584115289721_9097941373865881544_n.jpg" alt="طالب" />
            </div>
            <div className="testimonial-card">
              <img src="images/481714840_2452763971738402_8524035676421051699_n.jpg" alt="طالب" />
            </div>




            <div className="testimonial-card">
              <img src="images/d265a5f9-2b26-4c41-9c41-e6720898bf92.jpeg" alt="طالب" />
            </div>

            <div className="testimonial-card">
              <img src="images/0875e8a9-ee63-40c9-9b84-d7cb634863f9.jpeg" alt="طالبة" />
            </div>

            <div className="testimonial-card">
              <img src="images/896b8170-3fcb-48cf-a907-99031f78b8f9.jpeg" alt="طالب" />
            </div>


            <div className="testimonial-card">
              <img src="images/481816378_2449230225425110_488659043364239154_n.jpg" alt="طالب" />
            </div>

            <div className="testimonial-card">
              <img src="images/d265a5f9-2b26-4c41-9c41-e6720898bf92.jpeg" alt="طالب" />
            </div>



            <div className="testimonial-card">
              <img src="images/495371252_2508807422800723_6658301376037471885_n.jpg" alt="طالب" />
            </div>

            <div className="testimonial-card">
              <img src="images/d1721fc4-2f4c-4afe-9043-fc51b0362fa4.jpeg" alt="طالب" />
            </div>

            <div className="testimonial-card">
              <img src="images/63392706-6879-4e04-8485-2bd58ad34652.jpeg" alt="طالبة" />
            </div>

            <div className="testimonial-card">
              <img src="images/3891c697-cd96-4644-b73b-dfe1d095a19e.jpeg" alt="طالب" />
            </div>

            <div className="testimonial-card">
              <img src="images/76d8fa7d-8ea1-4964-ac73-98e4f879aaab.jpeg" alt="طالبة" />
            </div>

            <div className="testimonial-card">
              <img src="images/430685163_1094028291787210_7535007571737492698_n.jpg" alt="طالبة" />
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="faq-section">
        <div className="container">
          <h2 className="section-title">الأسئلة الشائعة</h2>
          <p className="section-subtitle">
            إجابات على أكثر الأسئلة شيوعاً حول المنحة التقنية الأضخم في العالم العربي
          </p>
          <div className="faq-container">
            <div className="faq-item">
              <div className="faq-question" onClick={() => setOpenFaq(openFaq === 1 ? null : 1)}>
                <h3>ايه هي شروط التقديم للمنحة؟</h3>
                <span className={`faq-toggle ${openFaq === 1 ? 'open' : ''}`}>+</span>
              </div>
              {openFaq === 1 && (
                <div className="faq-answer">
                  <p>المنحة متاحة لجميع الشباب العربي من عمر 14 إلى 40 سنة. مفيش شروط أكاديمية معينة، فقط الشغف بالتعليم والتطوير في المجال التقني.</p>
                </div>
              )}
            </div>

            <div className="faq-item">
              <div className="faq-question" onClick={() => setOpenFaq(openFaq === 2 ? null : 2)}>
                <h3>كم تكلفة رسوم التسجيل؟</h3>
                <span className={`faq-toggle ${openFaq === 2 ? 'open' : ''}`}>+</span>
              </div>
              {openFaq === 2 && (
                <div className="faq-answer">
                  <p>رسوم التسجيل رمزية جداً - 750 جنيه مصري فقط للحصول على دورات بقيمة آلاف الدولارات. الرسوم دي بتغطي جميع الكورسات .</p>
                </div>
              )}
            </div>

            {/* Removed FAQ item: هل الشهادات معتمدة دولياً؟ */}

            <div className="faq-item">
              <div className="faq-question" onClick={() => setOpenFaq(openFaq === 4 ? null : 4)}>
                <h3>كم مدة الدراسة لكل تخصص؟</h3>
                <span className={`faq-toggle ${openFaq === 4 ? 'open' : ''}`}>+</span>
              </div>
              {openFaq === 4 && (
                <div className="faq-answer">
                  <p>تختلف مدة كل تخصص حسب قوة التخصص، وتتراوح من 3-6 شهر.</p>
                </div>
              )}
            </div>

            <div className="faq-item">
              <div className="faq-question" onClick={() => setOpenFaq(openFaq === 5 ? null : 5)}>
                <h3>المحاضرات بتكون ازاي ؟</h3>
                <span className={`faq-toggle ${openFaq === 5 ? 'open' : ''}`}>+</span>
              </div>
              {openFaq === 5 && (
                <div className="faq-answer">
                  <p>المحاضرات بتكون لايف علي برنامج Zoom Meeting </p>
                </div>
              )}
            </div>

            <div className="faq-item">
              <div className="faq-question" onClick={() => setOpenFaq(openFaq === 6 ? null : 6)}>
                <h3>هل اقدر احضر في اي تخصص براحتي ؟</h3>
                <span className={`faq-toggle ${openFaq === 6 ? 'open' : ''}`}>+</span>
              </div>
              {openFaq === 6 && (
                <div className="faq-answer">
                  <p>تقدر تحضر في اي تخصص براحتك ، طبعا الافضل لانك تختار التخصص او الحاجات اللي بتساعد بعض عشان تقدر تستفاد وتركز</p>
                </div>
              )}
            </div>

            <div className="faq-item">
              <div className="faq-question" onClick={() => setOpenFaq(openFaq === 7 ? null : 7)}>
                <h3>هل المحاضرات بتتسجل ؟</h3>
                <span className={`faq-toggle ${openFaq === 7 ? 'open' : ''}`}>+</span>
              </div>
              {openFaq === 7 && (
                <div className="faq-answer">
                  <p>المحاضرات كلها بتتسجل وبتفضل معاك كمان</p>
                </div>
              )}
            </div>

            <div className="faq-item">
              <div className="faq-question" onClick={() => setOpenFaq(openFaq === 8 ? null : 8)}>
                <h3> ايه هو مستوي الانجليزي المطلوب </h3>
                <span className={`faq-toggle ${openFaq === 8 ? 'open' : ''}`}>+</span>
              </div>
              {openFaq === 8 && (
                <div className="faq-answer">
                  <p>  مش مشكلة لو مش كويس في الانجليزي  </p>
                </div>
              )}
            </div>


            <div className="faq-item">
              <div className="faq-question" onClick={() => setOpenFaq(openFaq === 9 ? null : 9)}>
                <h3> هل لازم يكون معايا شهاده معينه او كليه معينه ؟</h3>
                <span className={`faq-toggle ${openFaq === 9 ? 'open' : ''}`}>+</span>
              </div>
              {openFaq === 9 && (
                <div className="faq-answer">
                  <p> مسموح اي كليه ومش شرط شهاده معينه </p>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <p>&copy; 2026 المنحة الأضخم في العالم العربي - تمكين الشباب نحو المستقبل التقني</p>
        </div>
      </footer>

      {/* Track Details Modal */}
      {selectedTrack && (
        <div className="modal-overlay" onClick={closeTrackModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={closeTrackModal}>×</button>
            
            <div className="modal-header">
              <div className="modal-icon">{selectedTrack.icon}</div>
              <h2 className="modal-title">{selectedTrack.title}</h2>
              <p className="modal-description">{selectedTrack.description}</p>
            </div>

            <div className="modal-body">
              <div className="modal-stats">
                <div className="modal-stat">
                  <span className="stat-icon">⏱️</span>
                  <span className="stat-value">{selectedTrack.duration}</span>
                  <span className="stat-label">مدة الدورة</span>
                </div>
                <div className="modal-stat">
                  <span className="stat-icon">👨‍🏫</span>
                  <span className="stat-value">{selectedTrack.instructors?.length || 0}</span>
                  <span className="stat-label">المهندسين</span>
                </div>
                <div className="modal-stat">
                  <span className="stat-icon">🎯</span>
                  <span className="stat-value">متخصص</span>
                  <span className="stat-label">نوع الدورة</span>
                </div>
              </div>

              <div className="modal-section">
                <h3>المهارات التي ستتعلمها</h3>
                <div className="skills-grid">
                  {selectedTrack.skills.map((skill, index) => (
                    <span key={index} className="skill-tag">{skill}</span>
                  ))}
                </div>
              </div>

              <div className="modal-section">
                <h3>المهندسين الذين سيشرفون على التدريب</h3>
                <div className="instructors-grid">
                  {selectedTrack.instructors?.map((instructor, index) => (
                    <div key={index} className="instructor-tag">{instructor}</div>
                  ))}
                </div>
              </div>

              <div className="modal-actions">
                <button className="modal-register-btn" onClick={handleApplyClick}>
                  سجل في هذا المسار الآن
                </button>
                <button className="modal-contact-btn" onClick={handleWhatsAppContact}>
                  استفسر عبر الواتساب
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default App;
